module.exports = __webpack_public_path__ + "img/weinfo-career.d2151056.png";